/** Applies a mute/unmute state to a mediasoup producer and the underlying MediaStreamTrack together. */
export function applyTrackToggle(
  on: boolean,
  producer: { pause(): void; resume(): void } | undefined,
  track: MediaStreamTrack | undefined
): void {
  if (!producer) return;
  if (on) producer.resume();
  else producer.pause();
  if (track) track.enabled = on;
}
